export default __webpack_public_path__ + "static/media/about-1.c56523c5.jpg";